import {StyledGrid} from 'presentation/components';
import React from 'react';
import {ExamCard} from '../ExamCard';
import {ExamCardsGridType} from './types';

export const ExamCardsGrid = React.memo(({list}: ExamCardsGridType) => (
	<StyledGrid.Root spacing={2}>
		{list?.map((card, index) => (
			<StyledGrid.Item key={index} xs={12} sm={12} md={12} lg={4} xl={4}>
				<ExamCard exam={card} dataTestId={`exam-card-${index + 1}`} />
			</StyledGrid.Item>
		))}
	</StyledGrid.Root>
));
